"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.form_editor = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var form_editor = function form_editor(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'form_editor', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M13.9048 1.50537H3.33792C2.86847 1.50537 2.48792 1.88593 2.48792 2.35537V18.1618C2.48792 18.6312 2.86848 19.0118 3.33792 19.0118H17.1692C17.6386 19.0118 18.0192 18.6312 18.0192 18.1618V5.16828L16.5192 6.67127V17.5118H3.98792V3.00537H12.4078L13.9048 1.50537Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M10.0689 5.34894H6.09915C5.6297 5.34894 5.24915 5.7295 5.24915 6.19894V11.9945C5.24915 12.464 5.6297 12.8445 6.09915 12.8445H14.5091C14.9785 12.8445 15.3591 12.464 15.3591 11.9945V7.83364L13.8591 9.33663V11.3445H6.74915V6.84894H8.64638C8.71195 6.734 8.79286 6.62748 8.8876 6.53255L10.0689 5.34894Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M18.314 2.74945C18.7296 2.31955 18.664 1.58179 18.1679 1.10218C17.6716 0.622337 16.9324 0.581692 16.517 1.01139L9.94932 7.59216L9.71973 9.62805L11.7467 9.32981L18.314 2.74945Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M5.24915 14.9485C5.24915 14.5342 5.58493 14.1985 5.99915 14.1985H14.7937C15.2079 14.1985 15.5437 14.5342 15.5437 14.9485C15.5437 15.3627 15.2079 15.6985 14.7937 15.6985H5.99915C5.58493 15.6985 5.24915 15.3627 5.24915 14.9485Z',
    fill: '#4B5563'
  }));
};

exports.form_editor = form_editor;